module.exports = __webpack_public_path__ + "static/img/gognsi.ab42a140.jpg";